import Vue from 'vue';
import * as msal from '@azure/msal-browser';

let instance;

export const getInstance = () => instance;

const bootstrap = (pluginOptions) => {
  instance = new Vue({
    data() {
      return {
        msalClient: null,
        isLoading: true,
        isAuthenticated: false,
        user: null,
        error: null,
        scopes: {
          api: ['api://94b5f01a-af79-458f-9083-e3b23feb7bc7/access'],
          graph: ['Directory.Read.All', 'GroupMember.ReadWrite.All', 'User.Read'],
        },
        groups: {
          admin: '5d568826-07d5-4f47-bb14-8117ff5bffba',
          teacher: '0feeb022-9bd2-49b0-bddd-f20620355a4c',
          accountant: 'dd1ac941-af90-464f-851a-1b2ba2d0a8c9',
          student: 'e32a648f-aba3-4d50-bc19-f77ef8feda48',
        },
      };
    },

    methods: {
      hasRole(role) {
        if (!this.user?.idTokenClaims?.groups) return false;
        return this.user.idTokenClaims.groups.includes(this.groups[role]);
      },

      async handleRedirectPromise() {
        try {
          this.isLoading = true;
          const response = await this.msalClient.handleRedirectPromise();
          if (response !== null) {
            this.user = response.account;
            sessionStorage.setItem('homeAccountId', response.account.homeAccountId);
            this.isAuthenticated = true;
          } else {
            const currentAccounts = this.msalClient.getAllAccounts();
            if (currentAccounts.length > 1) {
              // could be possible after acquireTokenRedirect and other account selected
              const lastConnectedAccountId = sessionStorage.getItem('homeAccountId');
              const lastConnectedAccount = currentAccounts
                .find((account) => account.homeAccountId === lastConnectedAccountId);
              if (lastConnectedAccount) {
                this.user = lastConnectedAccount;
                this.isAuthenticated = true;
              }
            } else if (currentAccounts.length === 1) {
              [this.user] = currentAccounts;
              this.isAuthenticated = true;
            }
          }
        } catch (error) {
          // error in library or comming back from server
          this.error = error;
        } finally {
          this.isLoading = false;
        }
      },

      loginRedirect(options) {
        /*
        prompt: 'select_account'
        scopes: ['api://92c8d3c2-1e82-4fbf-acf7-d8ac6e71481b/access'],
        */
        return this.msalClient.loginRedirect(options);
      },

      logout(options) {
        return this.msalClient.logout(options);
      },

      async getToken(type = 'api') {
        try {
          const response = await this.msalClient
            .acquireTokenSilent({ account: this.user, scopes: this.scopes[type] });
          return `Bearer ${response.accessToken}`;
        } catch (error) {
          if (this.requiresInteraction(error)) {
            this.msalClient.acquireTokenRedirect({ scopes: this.scopes[type] });
          }
          return false;
        }
      },

      requiresInteraction(error) {
        if (!error || !error.length) {
          return false;
        }
        return error === 'consent_required'
          || error === 'interaction_required'
          || error === 'login_required';
      },
    },

    // instantiate the msal client
    async created() {
      this.msalClient = new msal.PublicClientApplication({
        auth: {
          ...pluginOptions,
          clientId: pluginOptions.clientId,
          authority: pluginOptions.authority,
          redirectUri: pluginOptions.redirectUri,
        },
      });

      this.handleRedirectPromise();
    },
  });

  return instance;
};

export const MsalPlugin = {
  // eslint-disable-next-line no-shadow
  install(Vue, options) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$auth = bootstrap(options);
  },
};
